import { getCurrentDesign } from "@tSurya/theme/design";

function buildBreakpoints() {
    var C = getCurrentDesign().COMMON;
    var maxWidth = C.breakpoints[C.breakpoints.length - 1];
    return {
        values: C.breakpoints,
        maxWidths: C.breakpoints.map(function() { return maxWidth; }),
    };
}

var breakpointsProxy = new Proxy({} as ReturnType<typeof buildBreakpoints>, {
    get: function(_target, prop) {
        return (buildBreakpoints() as any)[prop];
    },
    ownKeys: function() {
        return Object.keys(buildBreakpoints());
    },
    getOwnPropertyDescriptor: function(_target, prop) {
        var b = buildBreakpoints() as any;
        if (prop in b) {
            return { configurable: true, enumerable: true, writable: true, value: b[prop] };
        }
        return undefined;
    },
    has: function(_target, prop) {
        return prop in buildBreakpoints();
    }
});

export default breakpointsProxy;
